<div class="auth-page">
  <div class="auth-shell">
    <div class="auth-card">
      <div class="auth-brand">
        <img
          src="assets/favicon/android-chrome-192x192.png"
          [attr.alt]="'COMPONENTS.AUTH.BRAND_ALT' | translate"
          class="auth-brand-logo"
        />
        <h1 class="auth-brand-title">OrgLines</h1>
      </div>

      <form [formGroup]="formModel.form" (ngSubmit)="submitForm()" class="auth-form">
        <div>
          <label for="email-input" class="auth-field-label">{{ "INPUTS.EMAIL" | translate }}</label>
          <input
            id="email-input"
            type="email"
            class="input-field-lg auth-input w-full"
            [attr.placeholder]="'INPUTS.EMAIL' | translate"
            [class.is-invalid]="(emailFormControl.touched || formModel.form.dirty) && emailFormControl.errors"
            [class.is-valid]="!emailFormControl.errors"
            [formControlName]="formModel.fieldNames.email"
          />
          <ng-container
            *ngTemplateOutlet="
              validationErrorsTemplate;
              context: { errors: emailFormControl.errors }
            "
          ></ng-container>
        </div>

        <div>
          <label for="pwd-input" class="auth-field-label">{{ "INPUTS.PASSWORD" | translate }}</label>
          <input
            id="pwd-input"
            type="password"
            class="input-field-lg auth-input w-full"
            [attr.placeholder]="'INPUTS.PASSWORD' | translate"
            [class.is-invalid]="(passwordFormControl.touched || passwordFormControl.dirty) && passwordFormControl.errors"
            [class.is-valid]="!passwordFormControl.errors"
            [formControlName]="formModel.fieldNames.password"
          />
          <ng-container
            *ngTemplateOutlet="
              validationErrorsTemplate;
              context: { errors: passwordFormControl.errors }
            "
          ></ng-container>
        </div>

        <button
          type="submit"
          class="btn-primary auth-submit w-full rounded-xl"
          [disabled]="formModel.form.invalid"
        >
          {{ "BUTTONS.REGISTER" | translate }}
        </button>
      </form>

      <div class="auth-divider">
        <div class="auth-divider-line"></div>
        <span class="auth-divider-text">{{ "COMPONENTS.AUTH.OR" | translate }}</span>
        <div class="auth-divider-line"></div>
      </div>

      <div class="auth-links">
        <p>
          {{ "COMPONENTS.REGISTRATION.HAVE_ACCOUNT" | translate }}
          <a routerLink="/login">{{ "COMPONENTS.REGISTRATION.LOGIN_LINK" | translate }}</a>
        </p>
      </div>

      <div class="auth-divider">
        <div class="auth-divider-line"></div>
      </div>

      <div class="auth-language">
        <app-language-switcher [formControl]="formModel.form.controls.interfaceLanguage" />
      </div>
    </div>
    <p class="auth-footer-note">{{ "COMPONENTS.AUTH.FOOTER_NOTE" | translate }}</p>
  </div>
</div>

<ng-template #validationErrorsTemplate let-errors="errors">
  <ul class="invalid-feedback mt-2" *ngIf="errors">
    <li *ngIf="errors['required']">{{ "ERRORS.REQUIRED" | translate }}</li>
    <li *ngIf="errors['email']">{{ "ERRORS.EMAIL" | translate }}</li>
    <li *ngIf="errors['minlength']">
      {{
        "ERRORS.MINLENGTH"
          | translate: { requiredLength: errors["minlength"].requiredLength }
      }}
    </li>
    <li *ngIf="errors['maxlength']">
      {{
        "ERRORS.MAXLENGTH"
          | translate: { requiredLength: errors["maxlength"].requiredLength }
      }}
    </li>
    <li *ngIf="errors['hasDigit']">{{ "ERRORS.HAS_DIGIT" | translate }}</li>
    <li *ngIf="errors['hasLowerCase']">{{ "ERRORS.HAS_LOWERCASE" | translate }}</li>
    <li *ngIf="errors['hasUpperCase']">{{ "ERRORS.HAS_UPPERCASE" | translate }}</li>
    <li *ngIf="errors['hasNonAlphaNumeric']">{{ "ERRORS.HAS_NON_ALPHANUMERIC" | translate }}</li>
  </ul>
</ng-template>

<app-toasts></app-toasts>

<ng-template #dangerTpl>
  {{ callbackError }}
</ng-template>
